module.exports = __webpack_public_path__ + "img/picto8.c70feeb1.svg";